/**
 * Domain types for the reconciliation engine.
 *
 * This package is deliberately dependency-free (AGENT.md, docs/tech-stack.md §4):
 * no I/O, no framework imports, not even Zod. Wire-level validation lives in
 * `@picklii/shared`; this package assumes already-parsed rows and concerns itself
 * only with the reconciliation.
 *
 * Money is integer cents everywhere. Never floats. ADR-0002.
 */
/** Ordinal rank of a band, high to low. Used for deterministic ordering. */
export const BAND_RANK = Object.freeze({
    Critical: 3,
    High: 2,
    Medium: 1,
    Low: 0,
});
//# sourceMappingURL=types.js.map